import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';

interface NavState {
  from?: string;
  search?: string;
}

/**
 * Breadcrumb "← Movimenti magazzino" mostrato in cima ai form documento
 * (PSC/LNP/MPG/CON/MSS/MSF/INV/SAP) SOLO se l'utente è arrivato dalla pagina
 * /stock-movements via Link con state `{ from: 'stock-movements', search: '...' }`.
 *
 * Click → navigate('/stock-movements' + state.search), ripristinando tutti i
 * filtri attivi che erano nell'URL della lista al momento del click.
 *
 * Se l'utente apre il form documento direttamente (senza passare da
 * /stock-movements) il componente non renderizza nulla.
 */
export function BackToStockMovementsLink() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const state = (location.state ?? null) as NavState | null;
  if (!state || state.from !== 'stock-movements') return null;

  const targetSearch = state.search ?? '';
  return (
    <button
      type="button"
      onClick={() => navigate(`/stock-movements${targetSearch}`)}
      className="inline-flex items-center gap-1.5 text-sm text-brand-700 hover:text-brand-800 hover:underline"
    >
      <ArrowLeft className="w-4 h-4" />
      {t('stockMovements.list.title')}
    </button>
  );
}
